<template>
  <div>
    <v-card class="ma-1" outlined>

      <v-card-title>
        Contact
        <v-spacer/>
        <v-btn x-small fab depressed color="primary" @click="dialog=!dialog">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider class="mx-4"/>

      <v-card-text style="height: 98px;">

        <template v-if="!hotel.static.contact.hotel.phone && !hotel.static.contact.hotel.email && !hotel.static.contact.hotel.website">
          <v-alert dark color="error">
            <v-row no-gutters align="center">
              <v-icon left>mdi-alert</v-icon>
              Datele de contact nu sunt completate.
            </v-row>
          </v-alert>
        </template>

        <template v-else>
          <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
            <v-icon small left>mdi-phone</v-icon>
            {{hotel.static.contact.hotel.phone}}
          </div>
          <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
            <v-icon small left>mdi-email</v-icon>
            {{hotel.static.contact.hotel.email}}
          </div>
          <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
            <v-icon small left>mdi-web</v-icon>
            {{hotel.static.contact.hotel.website}}
          </div>
        </template>

      </v-card-text>

    </v-card>

    <v-dialog v-model="dialog" width="960">
      <v-card>

        <v-toolbar class="primary title white--text" flat dark>
          Date de contact
          <v-spacer/>
          <v-btn icon @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-4">
          <v-row no-gutters>

            <v-col cols="12">
              <div class="subtitle-1 font-weight-bold ma-1">
                Date generale de contact ale hotelului
              </div>
            </v-col>
            <v-col cols="3">
              <v-text-field v-model="hotel.static.contact.hotel.email" class="ma-1" label="Email" dense outlined hide-details/>
            </v-col>
            <v-col cols="3">
              <v-text-field v-model="hotel.static.contact.hotel.phone" class="ma-1" label="Telefon" dense outlined hide-details/>
            </v-col>
            <v-col cols="3">
              <v-text-field v-model="hotel.static.contact.hotel.website" class="ma-1" label="Website" dense outlined hide-details/>
            </v-col>
            <v-col cols="3">
              <v-text-field v-model="hotel.static.contact.hotel.fax" class="ma-1" label="Fax" dense outlined hide-details/>
            </v-col>

            <v-col cols="12">
              <div class="subtitle-1 font-weight-bold ma-1">
                Persoane de contact
              </div>
            </v-col>
            <template v-if="hotel.static.contact.people.length">
              <template v-for="person in hotel.static.contact.people">
                <v-col cols="12">
                  <v-row no-gutters class="flex-nowrap">
                    <v-text-field v-model="person.name" class="ma-1" label="Nume" dense outlined hide-details/>
                    <v-text-field v-model="person.email" class="ma-1" label="Email" dense outlined hide-details/>
                    <v-text-field v-model="person.position" class="ma-1" label="Pozitie" dense outlined hide-details/>
                    <v-text-field v-model="person.phone" class="ma-1" label="Telefon" dense outlined hide-details/>
                    <div class="ma-1">
                      <v-btn height="40" block depressed color="error" @click="remove(person)">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-row>
                </v-col>
              </template>
            </template>

            <v-col cols="3">
              <v-btn class="ma-1" depressed color="success" @click="add">
                <v-icon left>mdi-plus</v-icon>
                Persoana
              </v-btn>
            </v-col>

          </v-row>
        </v-card-text>

        <v-divider class="mx-2"/>

        <v-card-actions>
          <v-btn color="primary" text @click="cancel">
            Anuleaza
          </v-btn>
          <v-spacer/>
          <v-btn color="primary" depressed @click="save">
            Salveaza
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>

</template>

<script>
  export default {

    props: {
      hotel: Object,
    },

    data: () => ({
      dialog: false
    }),

    methods: {

      save() {
        this.$emit('save');
        this.dialog = false;
      },

      cancel() {
        this.$emit('cancel');
        this.dialog = false;
      },

      add() {
        if (this.hotel.static.contact.people.length >= 5)
          return;

        this.hotel.static.contact.people.push({
          name: null,
          email: null,
          position: null,
          phone: null
        });
      },

      remove(person) {
        this.hotel.static.contact.people.splice(this.hotel.static.contact.people.indexOf(person), 1);
      }

    }

  }
</script>